import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {IController, IModule, IPromise, ITimeoutService} from "angular";

const css = require('./mdButtonMedLasterIndikator.scss');

export class MdButtonMedLasterIndikatorKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular.component('wkMdButtonMedLasterIndikator', {
            bindings: {
                klikk: '&',
                mdDisabled: '<?',
                mdClass: '@?',
                mdType: '@?'
            },
            transclude: true,
            controller: MdButtonMedLasterIndikatorKontroller.forInjisering(),
            template: require('./mdButtonMedLasterIndikator.html')
        });
    }

    static forInjisering() {
        return [
            regNavn.ng.$timeout,
            MdButtonMedLasterIndikatorKontroller
        ]
    }

    constructor(private $timeout: ITimeoutService) {
    }

    klikk: (JQueryEventObject) => IPromise<any>; //settes via bindings
    mdDisabled: boolean; //settes via bindings
    mdClass: string; //settes via bindings
    mdType: 'submit' | null; //settes via bindings

    deaktivert = false;

    vedKlikk($event: JQueryEventObject) {
        if (this.deaktivert) return;

        let promise = this.klikk($event);
        if (!promise || !promise.finally) {
            console.warn("wkMdButtonMedLasterIndikator - forventet at klikk() returnerer et promise")
            return;
        }

        this.deaktivert = true;
        promise.finally(() => this.deaktivert = false);
    }

    $onInit(): void {
    }

}

